import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import { firestorePlugin } from 'vuefire'
import Vuetify from 'vuetify/lib'
// import colors from 'vuetify/es5/util/colors'
import { library } from '@fortawesome/fontawesome-svg-core'
import 'vuetify/dist/vuetify.min.css'
import VueYoutube from 'vue-youtube'
import wysiwyg from 'vue-wysiwyg'
import VuejsTypographyFilters from 'vuejs-typography-filters'
import store from '@/store/index'
import VueAnalytics from 'vue-analytics'
import VueMouseParallax from 'vue-mouse-parallax'
import vueClapButton from 'vue-clap-button'

import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faMedium } from '@fortawesome/free-brands-svg-icons/faMedium'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub'

var VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  router,
  autoTracking: {
    screenview: true,
    shouldRouterUpdate (to, from) {
      return to.path !== from.path
    },
    pageviewTemplate (route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})

library.add({
  faYoutube,
  faTwitter,
  faMedium,
  faInstagram,
  faGithub
})

Vue.use(VuejsTypographyFilters)
Vue.use(wysiwyg, {})
Vue.use(Vuetify, {
  theme: {
    primary: '#34b233',
    secondary: '#044027',
    accent: '#26547C',
    info: '#27CFCC',
    warning: '#F3D754',
    success: '#0DAB76',
    error: '#F32757'
  },
  iconfont: 'fabSvg'
})

Vue.use(firestorePlugin)
Vue.use(VueYoutube)
Vue.use(VueMouseParallax)
Vue.use(vueClapButton)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
